import { useEffect, useState, useContext, useCallback } from 'react'
import OLSelect from 'ol/interaction/Select';
import { MapContext } from './Map';
import { isNullOrUndefined } from 'util';

export default (props) => {

	const map = useContext(MapContext)
	const [olSelect, setOlSelect] = useState()

	const updateSelectedFeatures = useCallback((features) => {
		olSelect.getFeatures().clear();

		if (!isNullOrUndefined(features)) {
			features.forEach(feature => olSelect.getFeatures().push(feature));
		}
	}, [olSelect])

	useEffect(() => {
		setOlSelect(new OLSelect())
	}, [])

	useEffect(() => {
		if (!map) return
		if (!olSelect) return

		map.addInteraction(olSelect)

		return (() => {
			map.removeInteraction(olSelect)
		})
	}, [map, olSelect])

	useEffect(() => {
		if (!map) return
		if (!olSelect) return

		updateSelectedFeatures(props.features)
	}, [map, olSelect, props.features, updateSelectedFeatures])

	return null
}